module.exports = __webpack_public_path__ + "media/images/about-logo-nssf-1b753a2fc399cf0929b49995867ee1d4.png";